import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";
import { CACHE_TTL } from "./cacheConfig";

export const industryAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getIndustries: build.query({
            query: (body) => `/api/Industries/DataTablesSource${buildManagePageQueryString(body.columns, body.page, body.searchTerm, (body.page - 1) * body.limit, body.limit, body.orderColumnIndex, body.isDescSortDir)}`
        }),
        getAllIndustries: build.query({
            query: (body) => ({
                url: `/api/Industries/UserGet`,
                // url: `/api/Industries/UserGetWithValue?value=${body?.value || ''}`,
                responseHandler: (res: any) => res.json().then((res: any) => {
                    if (body?.asSelectOptions) {
                        return res.map((item: any) => ({ value: item.Id, label: item.DisplayName }))
                    } else {
                        return res;
                        // .map((item: any) => ({ id: item.Id, name: item.Name }))
                    }
                }),
            }),
            // No tag/invalidation exists for industries (stable admin reference data);
            // rely on the bounded REFERENCE window per spec 12 / FE-5 criterion 3(b).
            keepUnusedDataFor: CACHE_TTL.REFERENCE,
        }),
        createIndustry: build.mutation({
            query: (body) => ({
                url: '/api/Industries/AdminPost',
                method: 'POST',
                body,
            }),
        }),
        updateIndustry: build.mutation({
            query: (body) => {
                return {
                    url: `/api/Industries/AdminPut/${body.Id}`,
                    method: 'PUT',
                    body,
                }
            }
        }),
        deleteIndustry: build.mutation({
            query: (body) => ({
                url: `/api/Industries/AdminDelete${body.id}`,
                method: 'DELETE',
            }),
        })
    }),
})

export const {
    useGetIndustriesQuery,
    useDeleteIndustryMutation,
    useCreateIndustryMutation,
    useUpdateIndustryMutation,
    useGetAllIndustriesQuery,
} = industryAPI;